erpnext.ProductGrid = class CustomProductGrid extends erpnext.ProductGrid {
    constructor(options) {
        super(options);
    }

    get_primary_button(item, settings) {
        if (item.has_variants) {
            return `
                <a href="/${ item.route || '#' }">
                    <div class="btn btn-sm btn-explore-variants w-100 mt-4">
                        ${ __('Explore') }
                    </div>
                </a>
            `;
        } else if (settings.enabled && (settings.allow_items_not_in_stock || item.in_stock)) {
            return `
                <div id="${ item.name }" class="btn
                    btn-sm btn-primary btn-add-to-cart-list
                    w-100 mt-2 ${ item.in_cart ? 'hidden' : '' }"
                    data-item-code="${ frappe.utils.escape_html(item.item_code) }">
                    <span class="mr-2">
                        <svg class="icon icon-md">
                            <use href="#icon-assets"></use>
                        </svg>
                    </span>
                    ${ settings.enable_checkout ? __('Add to Cart') :  __('Add to Quote') }
                </div>

                <a href="/cart">
                    <div id="${ item.name }" class="btn
                        btn-sm btn-primary btn-go-to-cart
                        w-100 mt-4 go-to-cart-grid
                        ${ item.in_cart ? '' : 'hidden' }"
                        data-item-code="${ frappe.utils.escape_html(item.item_code) }">
                        ${ settings.enable_checkout ? __('Go to Cart') :  __('Go to Quote') }
                    </div>
                </a>
            `;
        } else {
            return ``;
        }
    }

    get_stock_availability(item, settings) {
        if (settings.show_stock_availability && !item.has_variants) {
            if (item.on_backorder) {
                return `
					<span class="out-of-stock mb-2 mt-1" style="color: var(--primary-color)">
						${__("Available on backorder")}
					</span>
				`;
            } else if (!item.in_stock) {
                return `
					<span class="out-of-stock mb-2 mt-1">
						${__("Out of stock")}
					</span>
				`;
            } else {
                let qty_label = "";
                if (item.show_stock_qty && item.stock_qty) {
                    qty_label = ` (${item.stock_qty})`;
                }

                return `
					<span class="in-stock mb-2 mt-1" style="color: var(--green-500, green)">
						${__("In Stock")}${qty_label}
					</span>
				`;
            }
        }

        return ``;
    }
};